import { handleResponse } from '@knowledgehound/data/fetchUtils'

const GREYHOUND_URL = () => process.env.REACT_APP_GREYHOUND_URL

export function getStudy (studyNumber) {
  return fetch(`/proxy/greyhound/studies/${studyNumber}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin'
  }).then(handleResponse)
}

export function getPublicStudy (studyId: string, jwt: string) {
  return fetch(`${GREYHOUND_URL()}/studies/${studyId}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: jwt
    },
    credentials: 'same-origin'
  }).then(handleResponse)
}
